// extracted by mini-css-extract-plugin
module.exports = {"About":"about_About__KC4Jr","Text":"about_Text__JXM8K","Info":"about_Info__xr7jN"};